import React from 'react';

import { charts } from '../../constants/event';
import PeriodChart from '../../chart/period/PeriodChart';

const PeriodsResult = (props) => {
  const { options } = props;

  return <div>{charts.includes(options.view) && <PeriodChart {...props} />}</div>;
};

export default PeriodsResult;
